import { Link, usePage } from "@inertiajs/react"
import BrandsCarousel from "../Brands/BrandCarousel"

export const ShopPopularBrands = () => {
    const { brands } = usePage().props

    return (
        <div className="flex flex-col items-center w-full gap-12 p-4 mt-8 md:mt-16">
            <div className="relative flex-col items-center w-full gap-8 pt-8 lg:flex lg:gap-0 lg:px-0">
                <div className="flex flex-col items-center pb-4">
                    <h2 className="text-2xl font-bold text-black lg:text-3xl">
                        Shop by Popular Brands
                    </h2>
                    <p className="mt-4 text-sm font-normal text-black lg:text-xl">
                        Explore our most sought-after firearms manufacturers
                    </p>
                </div>
                <div className="w-full lg:w-[1280px] h-full">
                    <BrandsCarousel brands={brands} />
                </div>
            </div>

            <Link href={"/brands"}>
                <div className="lg:mt-0 sm:ms-5 lg:ms-0 flex h-[48px] w-[225px] text-neutral-50 rounded-md transition-colors bg-[#800020] hover:bg-maroon-light items-center justify-center">
                    View All
                </div>
            </Link>
        </div>
    )
}
